export default "__VITE_PUBLIC_ASSET__64274637__"